import { EXCLUSIVE_LAUNCH_ZONE_DEFAULTS } from '@/utils/constants';
import type { ExclusiveLaunchLayout, ExclusiveLaunchGame } from '@/types/zones/exclusive-zone';
import type { Brand, Region } from '@/types/constants';
import { isMobile } from '@/utils/devices';
import { getGameName, getProviderName } from '@/logic/game-adapter/game-adapter';
import type { RichTextElement } from '@/app/components/rich-text/rich-text.types';

type GetPopupContentProps = {
    portraitLayoutContent?: ExclusiveLaunchLayout;
    gameContent?: ExclusiveLaunchGame;
    categoryPath?: string;
    videoTrailerUrl?: string;
    launchDate?: string;
    exclusiveType: string;
    exclusiveLaunchType: string;
    isEarlyAccess?: boolean;
    description: any;
    region: Region;
    zoneUid: string;
};

export type ExclusivePopupContent = {
    exclusivePlaceholderLogo?: string;
    modalBackgroundImage?: string;
    announcementImage?: string;
    headlineLogo?: string;
    counterBackground?: string;
    videoPoster?: string;
    ctaText: string;
    copyrightText?: string;
    contentId: string;
    gameUid: string;
    categoryPath: string;
    videoTrailerUrl?: string;
    launchDate: string;
    exclusiveType: string;
    isEarlyAccess: boolean;
    descriptionText?: RichTextElement;
    playNowButtonText: string;
    launcherUrlProps: any;
    zoneUid: string;
    exclusiveLaunchType: string;
};

export const getPopupContent = ({
    portraitLayoutContent,
    gameContent,
    categoryPath,
    videoTrailerUrl,
    launchDate,
    description,
    exclusiveType,
    exclusiveLaunchType,
    isEarlyAccess = false,
    region,
    zoneUid
}: GetPopupContentProps): ExclusivePopupContent | null => {
    if (!portraitLayoutContent?.primary || !gameContent?.data) {
        return null;
    }

    const gameData = gameContent.data;
    const zoneContent = portraitLayoutContent.primary;

    const ctaButtonText = zoneContent?.cta_button_text;
    const playNowButtonText = ctaButtonText || EXCLUSIVE_LAUNCH_ZONE_DEFAULTS.PLAY_NOW_BUTTON;
    const isMobileDevice = isMobile(); // TODO: this is wrong here but the same is used in logic/exclusive-launch

    const launcherUrlProps = {
        providerName: getProviderName(gameContent.data?.provider?.data?.providername),
        region: region,
        brand: process?.env?.BRAND as Brand,
        gameName: getGameName(gameContent.data?.display_name),
        rgi: gameData?.rgi,
        ganId: gameData?.ganid,
        providerRef: isMobileDevice ? gameData?.rgs_code_mobile : gameData?.rgs_code_desktop,
        providerUid: gameData?.provider?.uid,
        gameId: gameContent?.id,
        gameUid: gameContent?.uid
    };

    let descriptionBlock: RichTextElement | undefined;

    if (description?.[0]?.spans?.length && description?.[0]?.text) {
        descriptionBlock = description[0];
    }

    return {
        exclusivePlaceholderLogo: zoneContent?.logo?.exclusive?.url,
        modalBackgroundImage: zoneContent?.background?.modal?.url,
        announcementImage: zoneContent?.announcement_background?.url,
        headlineLogo: zoneContent?.logo?.big?.url,
        counterBackground: zoneContent?.counter_background_image?.url,
        videoPoster: zoneContent?.video_loading_placeholder?.url,
        ctaText: zoneContent?.cta_button_text || EXCLUSIVE_LAUNCH_ZONE_DEFAULTS.PLAY_NOW_BUTTON,
        copyrightText: gameData?.copyright_text,
        contentId: `${portraitLayoutContent?.id}-popup`,
        gameUid: gameContent?.uid || '',
        categoryPath: categoryPath || '/',
        videoTrailerUrl,
        launchDate: launchDate || '',
        exclusiveType,
        isEarlyAccess,
        exclusiveLaunchType,
        descriptionText: descriptionBlock,
        playNowButtonText,
        launcherUrlProps,
        zoneUid
    };
};
